import {Injectable, Optional} from '@angular/core';
import {
  Configuration,
  LoginService,
  PasswordService,
  RegistrationService,
  UsersService
} from "../../generated/sales-terminal-client";
import { HttpClient } from "@angular/common/http";
import {cloneDeep} from "lodash-es";

export const PROXIED_SALES_TERMINAL_URI = '/proxy/sales-terminal';

@Injectable({
  providedIn: 'root'
})
export class ProxiedLoginService extends LoginService {
  constructor(protected httpClient: HttpClient, @Optional() configuration: Configuration) {
    const conf = cloneDeep(configuration);
    conf.basePath = PROXIED_SALES_TERMINAL_URI;
    conf.withCredentials = true;
    super(httpClient, conf.basePath, conf);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProxiedRegistrationService extends RegistrationService {
  constructor(protected httpClient: HttpClient, @Optional() configuration: Configuration) {
    const conf = cloneDeep(configuration);
    conf.basePath = PROXIED_SALES_TERMINAL_URI;
    conf.withCredentials = true;
    super(httpClient, conf.basePath, conf);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProxiedUsersService extends UsersService {
  constructor(protected httpClient: HttpClient, @Optional() configuration: Configuration) {
    const conf = cloneDeep(configuration);
    conf.basePath = PROXIED_SALES_TERMINAL_URI;
    conf.withCredentials = true;
    super(httpClient, conf.basePath, conf);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProxiedPasswordService extends PasswordService {
  constructor(protected httpClient: HttpClient, @Optional() configuration: Configuration) {
    const conf = cloneDeep(configuration);
    conf.basePath = PROXIED_SALES_TERMINAL_URI;
    conf.withCredentials = true;
    super(httpClient, conf.basePath, conf);
  }
}
